<template>
    <kubernetes-common-panel
            v-model="value"
            :img="img"
            :readOnly="readOnly"
            @openDesDoc="desDocOpen"
            @close="closePanel"
    >
        <template slot="headline">
            <v-tabs v-model="tabIdx">
                <v-tab
                    v-for="(tab, idx) in tabs"
                    :key="idx">
                    <v-list-item-title>{{ tab }}</v-list-item-title>
                </v-tab>
            </v-tabs>
        </template>

        <template slot="descriptionText">
            <span>{{ descriptionText }}</span>
        </template>

        <template slot="edit-layout">
             <v-layout wrap v-if="activeTab == 'Property'">
                <v-flex shrink style="width: 180px;">
                    <v-card flat>
                        <v-card-text>
                            <v-text-field
                                    label="Name"
                                    v-model="value.object.metadata.name"
                                    autofocus
                                    :disabled="readOnly"
                            ></v-text-field>
                            <v-text-field
                                    label="Host"
                                    v-model="value.object.spec.host"
                                    :disabled="readOnly"
                            ></v-text-field>
                            <kube-attr-field 
                                    v-model="value" 
                                    :readOnly="readOnly"
                            ></kube-attr-field>
                            <br />
                            <v-btn
                                    dark rounded color="primary"
                                    :disabled="readOnly"
                                    @click="addSubset">
                                ADD SUBSET
                            </v-btn>
                        </v-card-text>
                    </v-card>
                </v-flex>
                <v-flex>
                    <kube-yaml-editor
                            v-model="propertyData"
                            :readOnly="readOnly"
                    ></kube-yaml-editor>
                </v-flex>
            </v-layout>
            <v-layout wrap v-else>
                <v-flex shrink style="width: 200px;">
                    <v-card flat>
                        <v-card-text>
                            <v-checkbox
                                    label="Edit TrafficPolicy"
                                    v-model="editTrafficPolicy">
                            </v-checkbox>
                            <kube-number-field
                                :label="'Http1 Max Pending Requests'"
                                v-model="value.trafficPolicy.connectionPool.http.http1MaxPendingRequests"
                                :readOnly="readOnly || !editTrafficPolicy"
                            ></kube-number-field>
                            <kube-number-field
                                    :label="'Max Requests Per Connection'"
                                    :readOnly="readOnly || !editTrafficPolicy"
                                    v-model="value.trafficPolicy.connectionPool.http.maxRequestsPerConnection"
                            ></kube-number-field>
                            <kube-number-field
                                    :label="'Max Connections'"
                                    :readOnly="readOnly || !editTrafficPolicy"
                                    v-model="value.trafficPolicy.connectionPool.tcp.maxConnections"
                            ></kube-number-field>
                            <v-text-field
                                    label="Base Ejection Time"
                                    v-model="baseEjectionTime"
                                    :disabled="readOnly || !editTrafficPolicy"
                                    type="number"
                                    suffix="s"
                            ></v-text-field>
                            <kube-number-field
                                    :label="'Consecutive Errors'"
                                    :readOnly="readOnly || !editTrafficPolicy"
                                    v-model="value.trafficPolicy.outlierDetection.consecutiveErrors"
                            ></kube-number-field>
                            <v-text-field
                                    label="Interval"
                                    :disabled="readOnly || !editTrafficPolicy"
                                    v-model="interval"
                                    type="number"
                                    suffix="s"
                            ></v-text-field>
                            <kube-number-field
                                    :label="'Max Ejection Percent'"
                                    :readOnly="readOnly || !editTrafficPolicy"
                                    v-model="value.trafficPolicy.outlierDetection.maxEjectionPercent"
                            ></kube-number-field>
                        </v-card-text>
                    </v-card>
                </v-flex>
                <v-flex>
                    <kube-yaml-editor
                        v-model="trafficPolicy"
                        :readOnly="readOnly || !editTrafficPolicy"
                    ></kube-yaml-editor>
                </v-flex>
            </v-layout>
        </template>
    </kubernetes-common-panel>

</template>


<script>
    import KubernetesPanel from "../KubernetesPanel";

    export default {
        name: 'dr-property-panel',
        mixins: [KubernetesPanel],
        computed: {
            descriptionText() {
                return 'DestinationRule'
            },
            propertyData: {
                get() {
                    var data = JSON.parse(JSON.stringify(this.value.object));
                    delete data.spec.trafficPolicy;
                    return data;
                },
                set(val) {
                    _.merge(this.value.object, val);
                }
            },
            trafficPolicy: {
                get() {
                    return this.value.trafficPolicy
                },
                set(val) {
                    if(this.editTrafficPolicy) {
                        console.log(val)
                        _.merge(this.value.object.spec, { 'trafficPolicy': val })
                        this.value.trafficPolicy = val
                    }
                }
            },
            baseEjectionTime: {
                get() {
                    var val = this.value.trafficPolicy.outlierDetection.baseEjectionTime
                    val = val.split('s')[0]
                    return val
                },
                set(val) {
                    var me = this
                    me.value.trafficPolicy.outlierDetection.baseEjectionTime = val + 's'
                }
            },
            interval: {
                get() {
                    var val = this.value.trafficPolicy.outlierDetection.interval
                    val = val.split('s')[0]
                    return val
                },
                set(val) {
                    var me = this
                    me.value.trafficPolicy.outlierDetection.interval = val + 's'
                }
            },
            tabIdx: {
                get() {
                    return 0
                },
                set(val) {
                    var me = this
                    if(val == 0) {
                        me.activeTab = 'Property'
                    } else {
                        me.activeTab = 'TrafficPolicy'
                    }
                    if(me.value.object.spec.trafficPolicy) {
                        me.editTrafficPolicy = true
                    } else {
                        me.editTrafficPolicy = false
                    }
                }
            }
        },
        data: function () {
            return {
                activeTab: 'Property',
                tabs: [ 'Property', 'TrafficPolicy' ],
                editTrafficPolicy: false,
            }
        },
        watch: {
            editTrafficPolicy: {
                deep: true,
                handler(val) {
                    var me = this
                    if(val) {
                        _.merge(me.value.object.spec, {'trafficPolicy': me.value.trafficPolicy})
                    } else {
                        delete me.value.object.spec.trafficPolicy
                    }
                }
            }
        },
        methods: {
            addSubset() {
                var me = this;
                var attrList = Object.entries(me.value.advancedAttributePaths);
                attrList.forEach(([key, value]) => {
                    me.attrKey = key;
                    me.attrVal = value;
                });
                me.value.object.metadata.name = me.value.object.metadata.name + ",";
                me.$nextTick(function () {
                    _.set(me.value.object, me.attrKey, me.attrVal);
                    me.value.object.metadata.name = (me.value.object.metadata.name).replace(',', '');
                });
                
            }
        }
    }
</script>

